// Autogenerated by identity/acls/bin/generate_js.py
/* eslint-env node */

var APPS = {
    "ALPS": "alps",
    "ANALYZE": "analyze",
    "ANTI_FRAUD": "anti-fraud",
    "ATOMIC": "atomic",
    "BST": "bst",
    "CAPE_OFFLINE": "cape-offline",
    "CARD_LINKED_OFFERS": "card-linked-offers",
    "COMMS_OFFLINE": "comms-offline",
    "CREDIT_SERVICE_TU_INGESTER": "credit-service-tu-ingester",
    "DATA_SCIENCE_OFFLINE": "data-science-offline",
    "DEBT_APP_OFFLINE": "debt-app-offline",
    "DEBT_SERVICE_OFFLINE": "debt-service-offline",
    "DENALI": "denali",
    "DIT_EXPERT": "dit-experts",
    "DIT_MOBILE": "dit-mobile",
    "DIT_OFFLINE": "dit-offline",
    "DSS": "dss",
    "DWH_OFFLINE": "dwh-offline",
    "FACTORY_DCE_HANDLER": "factory-dce-handler",
    "FACTORY_OFFLINE": "factory-offline",
    "FACTORY_SYNCER": "factory-syncer",
    "FDP_ROLLUPS_OFFLINE": "fdp-rollups-offline",
    "FDP_SEGMENT_LAMBDAS": "fdp-segment-lambdas",
    "FDP_SOURCE": "fdp-source",
    "FEATURES": "features",
    "FEED": "feed",
    "FINANCIAL_DATA_PLATFORM": "financial-data-platform",
    "FINANCIAL_INSIGHTS_OFFLINE": "financial-insights-offline",
    "GATEWAY": "gateway",
    "IDENTITY": "identity",
    "INDY": "indy",
    "INTEGRATIONS_OFFLINE": "integrations-offline",
    "ISS": "iss",
    "MARKETPLACE": "marketplace",
    "MY_BILLS": "my-bills",
    "NERDWALLET_MOBILE": "nerdwallet-mobile",
    "NERDWALLET_WEB": "nerdwallet web",
    "NWADMIN": "nwadmin",
    "NW_AIRFLOW": "nw-airflow",
    "PERSONAL_LOANS_OFFLINE": "personal-loans-offline",
    "PREQUAL_SERVICE_OFFLINE": "prequal-service-offline",
    "QA_CRUD": "qa-crud",
    "RECOMMENDATION_SERVICE": "recommendation-service",
    "RECOMMENDATION_SERVICE_OFFLINE": "recommendation-service-offline",
    "RECURLY": "recurly",
    "REWARDS_OFFLINE": "rewards-offline",
    "SAVE_WITH_FRIENDS_OFFLINE": "save-with-friends-offline",
    "UCP": "ucp",
    "USER_FEED_OFFLINE": "user-feed-offline",
    "USER_OPS_DASHBOARD": "user-ops-dashboard",
    "WEALTH_RECOMMENDER": "wealth-recommender",
    "WLL": "wll"
};

var ROLES = {
    "AAA": {
        "ADMIN": "aaa/admin",
        "ADVISOR": "aaa/advisor"
    },
    "ANALYZE": {
        "TU_PROFILE_OFFLINE_WRITER": "analyze/tu-profile-offline-writer"
    },
    "ANTIFRAUD": {
        "ANTIFRAUD_ADMIN": "anti-fraud/admin",
        "ANTIFRAUD_EMAIL_BLOCKED_OFFLINE_READER": "anti-fraud/email-blocked-offline-reader",
        "ANTIFRAUD_EMAIL_BLOCKED_READER": "anti-fraud/email-blocked-reader",
        "ANTIFRAUD_OFFLINE_WORKER": "anti-fraud/offline-worker"
    },
    "BANKING": {
        "ADMIN": "banking/admin",
        "CONTENT": "banking/content",
        "DIGITAL_MARKETING": "banking/digital-marketing",
        "DIGITAL_MARKETING_ADMIN": "banking/digital-marketing-admin",
        "ENGINEER": "banking/engineer",
        "PRODUCT_MANAGER": "banking/product-manager"
    },
    "BST": {
        "BST_ADMIN": "bst/admin",
        "BST_EXTERNAL_PARTNER": "bst/external-partner"
    },
    "CC": {
        "DIGITAL_MARKETING": "cc/digital-marketing",
        "DIGITAL_MARKETING_ADMIN": "cc/digital-marketing-admin",
        "EXTERNAL_AUDITOR": "cc/external-auditor",
        "INTERNAL_OFFLINE_READER": "cc/internal-offline-reader",
        "NERDWALLET_COMPLIANCE": "cc/nerdwallet-compliance",
        "NERDWALLET_COMPLIANCE_ADMIN": "cc/nerdwallet-compliance-admin",
        "NERDWALLET_DEV": "cc/nerdwallet-dev",
        "NERDWALLET_OFFLINE_WRITER": "cc/nerdwallet-offline-writer"
    },
    "CLO": {
        "CLO_ENGINEER": "clo/engineer",
        "CLO_OFFLINE_READER": "clo/offline-reader"
    },
    "COMMS": {
        "COMMS_OFFLINE_APP_BADGE_COUNT_UPDATER": "comms/offline-app-badge-count-updater",
        "COMMS_OFFLINE_EMAIL_UPDATER": "comms/offline-email-updater",
        "COMMS_OFFLINE_EVENT_EMITTER": "comms/offline-event-emitter",
        "COMMS_OFFLINE_ITERABLE_DATA_EXPORTER": "comms/offline-iterable-data-exporter",
        "QA_COMMS_ADMIN": "comms/qa-comms-admin",
        "QA_COMMS_RECEIVER": "comms/qa-comms-receiver",
        "QA_COMMS_TESTER": "comms/qa-comms-tester"
    },
    "COMPLIANCE": {
        "ADMIN": "compliance/admin",
        "DATA_QUALITY": "compliance/data-quality"
    },
    "DENALI": {
        "ADMIN": "denali/admin",
        "ENGINEER": "denali/engineer",
        "PLACEMENT_OFFLINE_READER": "denali/placement-offline-reader"
    },
    "DIT": {
        "ADMIN": "dit/admin",
        "EDITOR": "dit/editor",
        "EXPERT": "dit/expert",
        "USER": "dit/user"
    },
    "DSS": {
        "ADMIN": "dss/admin",
        "ENGINEER": "dss/engineer"
    },
    "ESTATE_PLANNING": {
        "ADMIN": "estate-planning/admin",
        "ENGINEER": "estate-planning/engineer",
        "PRODUCT_MANAGER": "estate-planning/product-manager"
    },
    "EXPANSION": {
        "ADMIN": "expansion/admin",
        "ENGINEER": "expansion/engineer",
        "PRODUCT_MANAGER": "expansion/product-manager"
    },
    "FACTORY": {
        "FACTORY_CONFIG_SYNCER": "factory/factory-config-syncer",
        "FACTORY_OFFLINE_READER": "factory/factory-offline-reader",
        "FACTORY_SECURITY_ADMIN": "factory/factory-security-admin"
    },
    "FDP": {
        "FDP_ADMIN": "fdp/admin",
        "FDP_APP": "fdp/app",
        "FDP_ENGINEER": "fdp/engineer",
        "FDP_FINANCIAL_DATA_OFFLINE_READER": "fdp/financial-data-offline-reader",
        "FDP_FINANCIAL_DATA_OFFLINE_WRITER": "fdp/financial-data-offline-writer",
        "FDP_PLAID_SOURCE": "fdp/plaid-source",
        "FDP_PRODUCT_MANAGER": "fdp/product-manager",
        "FDP_PROXY": "fdp/proxy",
        "FDP_QA_ENGINEER": "fdp/qa-engineer",
        "FDP_QA_SOURCE": "fdp/qa-source",
        "FDP_REDFIN_SOURCE": "fdp/redfin-source",
        "FDP_ROLLUPS_OFFLINE_COMPUTER": "fdp/rollups-offline-computer",
        "FDP_SUPPORT": "fdp/support",
        "FDP_USER_DEACTIVATOR": "fdp/user-deactivator",
        "FDP_USER_SOURCE_OFFLINE_WRITER": "fdp/user-source/offline-writer",
        "FDP_USER_TRANSACTION_RULES_OFFLINE_WRITER": "fdp/user-transaction-rules-offline-writer"
    },
    "HOME": {
        "HOME_ADMIN": "home/admin",
        "HOME_CONTENT": "home/content",
        "HOME_ENGINEER": "home/engineer",
        "HOME_PRODUCT_MANAGER": "home/product-manager"
    },
    "IDENTITY": {
        "ACH_KYC_ADDRESS_OFFLINE_READER": "identity/ach-kyc-address-offline-reader",
        "ALL_DATA_OFFLINE_READER": "identity/all-data-offline-reader",
        "ANTI_FRAUD_OFFLINE_CALLBACKS_CALLER": "identity/anti-fraud-callbacks-offline-caller",
        "CARD_LINKED_OFFERS_OFFLINE_READER": "identity/card-linked-offers-offline-reader",
        "CREDIT_SERVICE_OFFLINE_READER": "identity/credit-builder-offline-reader",
        "DEBT_SERVICE_OFFLINE_DEBT_WRITER": "identity/debt-service-offline-debt-writer",
        "EMAIL_PROFILE_OFFLINE_READER": "identity/email-profile-offline-reader",
        "EMAIL_SUBSCRIPTION_OFFLINE_ADMIN": "identity/email-subscription-offline-admin",
        "FEATURE_FLAG_OFFLINE_READER": "identity/feature-flag-offline-reader",
        "FEATURE_FLAG_TRUSTED_OFFLINE_READER": "identity/feature-flag-trusted-offline-reader",
        "FINANCIAL_DATA_WRITER": "identity/financial-data-writer",
        "GLOBAL_PROFILE_OFFLINE_READER": "identity/global-profile-offline-reader",
        "GLOBAL_PROFILE_OFFLINE_WRITER": "identity/global-profile-offline-writer",
        "GOALS_PROFILE_OFFLINE_READER": "identity/goals-profile-offline-reader",
        "NW_PLUS_MEMBER_OFFLINE_WRITER": "identity/nw-plus-member-offline-writer",
        "RECOMMENDATION_SERVICE_OFFLINE_READER": "identity/recommendation-service-offline-reader",
        "TEST_STATE_PROFILE_OFFLINE_READER": "identity/test-state-profile-offline-reader",
        "TU_META_OFFLINE_WRITER": "identity/tu-meta-offline-writer",
        "TU_PROFILE_READER": "identity/tu-profile-reader",
        "VERIFICATION_RECORDS_OFFLINE_READER": "identity/verification-records-offline-reader",
        "YODLEE_OFFLINE_READER": "identity/yodlee-offline-reader"
    },
    "INSURANCE": {
        "ADMIN": "insurance/admin",
        "ENGINEER": "insurance/engineer",
        "PRODUCT_MANAGER": "insurance/product-manager"
    },
    "INVESTING": {
        "ADMIN": "investing/admin",
        "CONTENT": "investing/content",
        "DIGITAL_MARKETING": "investing/digital-marketing",
        "DIGITAL_MARKETING_ADMIN": "investing/digital-marketing-admin",
        "ENGINEER": "investing/engineer",
        "PRODUCT_MANAGER": "investing/product-manager"
    },
    "LEX": {
        "LEX_FINANCIAL_HEALTH_SCORE_OFFLINE_READER": "lex/financial-health-score/offline-reader"
    },
    "LOANS": {
        "ADMIN": "loans/admin",
        "CONTENT": "loans/content",
        "ENGINEER": "loans/engineer",
        "PRODUCT_MANAGER": "loans/product-manager"
    },
    "MARKETPLACE": {
        "ADMIN": "marketplace/admin",
        "AFFILIATE_PAYOUT_OFFLINE_READER": "marketplace/affiliate-payout-offline-reader",
        "AFFILIATE_PAYOUT_OFFLINE_WRITER": "marketplace/affiliate-payout-offline-writer",
        "DATA_QUALITY": "marketplace/data-quality",
        "ENGINEER": "marketplace/engineer"
    },
    "ML_PLATFORM": {
        "ADMIN": "ml-platform/admin",
        "AIRFLOW": "ml-platform/airflow",
        "CLIENT": "ml-platform/client",
        "DATA_SCIENTIST": "ml-platform/data-scientist",
        "ENGINEER": "ml-platform/engineer",
        "QA_ENGINEER": "ml-platform/qa-engineer"
    },
    "MOVING": {
        "ADMIN": "moving/admin",
        "ENGINEER": "moving/engineer",
        "PRODUCT_MANAGER": "moving/product-manager"
    },
    "NERDWALLET": {
        "ASK_MY_FRIENDS_ADMIN": "nerdwallet/ask-my-friends-admin",
        "BIZ_DEV": "nerdwallet/biz-dev",
        "BIZ_DEV_EDITOR": "nerdwallet/biz-dev-editor",
        "DATA_SCIENTIST": "nerdwallet/data-scientist",
        "DEVELOPER_TESTER": "nerdwallet/developer-tester",
        "DEVOPS": "nerdwallet/devops",
        "EMPLOYEE": "nerdwallet/employee",
        "ENGINEER": "nerdwallet/engineer",
        "EXTERNAL_BETA_TESTER": "nerdwallet/external-beta-tester",
        "EXTERNAL_RESEARCH_USER": "nerdwallet/external-research-user",
        "EXTERNAL_TESTER_ADMIN": "nerdwallet/external-tester-admin",
        "FEED_ENGINEER": "nerdwallet/feed-engineer",
        "HAS_ACTIVATED_TRANSUNION": "nerdwallet/has_activated_transunion",
        "HAS_PASSED_CAPTCHA": "nerdwallet/has_passed_captcha",
        "HAS_SECURITY_CHALLENGE": "nerdwallet/has_security_challenge",
        "HAS_VERIFIED_OTP": "nerdwallet/has_verified_otp",
        "HAS_VERIFIED_PHONE": "nerdwallet/has_verified_phone",
        "HAS_VERIFIED_TRANSUNION_OTP": "nerdwallet/has_verified_transunion_otp",
        "IDENTITY_ENGINEER": "nerdwallet/identity-engineer",
        "IDENTITY_LEAD": "nerdwallet/identity-lead",
        "IDENTITY_SUPPORT": "nerdwallet/identity-support",
        "INTERNAL_TESTER": "nerdwallet/internal-tester",
        "LOGGED_IN": "nerdwallet/logged_in",
        "MARKETER": "nerdwallet/marketer",
        "NW_PLUS_MEMBER": "nerdwallet/plus_member",
        "NW_PLUS_REDEEM_ONLY_MEMBER": "nerdwallet/plus_redeem_only_member",
        "NW_PLUS_TRIAL_MEMBER": "nerdwallet/plus_trial_member",
        "OFFLINE_EMAILER": "nerdwallet/offline_emailer",
        "OFFLINE_EMAIL_READER": "nerdwallet/offline_email_reader",
        "OFFLINE_FACT_READER": "nerdwallet/offline_fact_reader",
        "OFFLINE_IAV_ACCOUNT_DETAILS_READER": "nerdwallet/offline_iav_account_details_reader",
        "OFFLINE_IDENTITY_READER": "nerdwallet/offline_identity_reader",
        "OFFLINE_IDENTITY_ROLES_READER": "nerdwallet/offline_identity_roles_reader",
        "OFFLINE_YODLEE_DATA_WRITER": "nerdwallet/offline_yodlee_data_writer",
        "PRODUCT_MANAGER": "nerdwallet/product_manager",
        "QUALITY_ASSURANCE": "nerdwallet/quality-assurance",
        "QUALITY_ASSURANCE_ADMIN": "nerdwallet/quality-assurance-admin",
        "QUALITY_ASSURANCE_ENGINEER": "nerdwallet/quality-assurance-engineer",
        "REUSABLE_PHONE_NUMBER": "nerdwallet/reusable-phone-number",
        "REWARDS_ENGINEER": "nerdwallet/rewards-engineer",
        "REWARDS_SUPPORT": "nerdwallet/rewards-support",
        "SECURITY_ENGINEER": "nerdwallet/security-engineer",
        "SWEEP_ADMIN": "nerdwallet/sweep-admin",
        "SWEEP_ENGINEER": "nerdwallet/sweep-engineer"
    },
    "PERSONAL_LOANS": {
        "OFFLINE_EMAILER": "personal-loans/offline-emailer"
    },
    "PREQUAL_OFFERS": {
        "PREQUAL_OFFLINE_READER": "prequal/offline-reader",
        "PREQUAL_OFFLINE_WRITER": "prequal/offline-writer"
    },
    "REWARDS": {
        "OFFLINE_READER": "rewards/offline-reader"
    },
    "SOFTWARE": {
        "ADMIN": "software/admin",
        "ENGINEER": "software/engineer",
        "PRODUCT_MANAGER": "software/product-manager"
    },
    "TAXES": {
        "ADMIN": "taxes/admin",
        "COLUMN_TAX_ADMIN": "taxes/column-tax-admin",
        "CONTENT": "taxes/content",
        "ENGINEER": "taxes/engineer",
        "PRODUCT_MANAGER": "taxes/product-manager"
    },
    "THIRD_PARTY_EMBEDS": {
        "ADMIN": "third-party-embeds/admin",
        "EMBED_MANAGER": "third-party-embeds/embed-manager",
        "ENGINEER": "third-party-embeds/engineer",
        "PRODUCT_MANAGER": "third-party-embeds/product-manager"
    },
    "TRANSUNION": {
        "TU_SENSITIVE_DATA_READER": "tu/sensitive-credit-data-reader"
    },
    "UCP": {
        "UCP_ADMIN": "ucp/admin",
        "UCP_CCPA_ENGINEER": "ucp/ccpa-engineer",
        "UCP_ENGINEER": "ucp/engineer",
        "UCP_QA": "ucp/qa"
    },
    "UDP": {
        "AFS_AUGMENTOR_CACHE_OFFLINE_WORKER": "udp/afs-augmentor-cache-offline-worker",
        "MEMBER_BACKFILL_WRITER": "udp/member-backfill-writer",
        "PROFILES_OFFLINE_READER": "udp/profiles-offline-reader",
        "PROFILES_OFFLINE_WRITER": "udp/profiles-offline-writer",
        "PROFILES_READER": "udp/profiles-reader",
        "UDP_ADMIN": "udp/admin",
        "UDP_ENGINEER": "udp/engineer",
        "UNIFIED_USER_PROFILE_OFFLINE_READER": "udp/unified-user-profiles-offline-reader",
        "VISITOR_BACKFILL_WRITER": "udp/visitor-backfill-writer",
        "VISITOR_PII_OFFLINE_READER": "udp/visitor-pii-offline-reader",
        "VISITOR_PII_READER": "udp/visitor-pii-reader"
    },
    "UTILITIES": {
        "ADMIN": "utilities/admin",
        "CONTENT": "utilities/content",
        "ENGINEER": "utilities/engineer",
        "PRODUCT_MANAGER": "utilities/product-manager"
    },
    "VISITOR_IDENTITY": {
        "VISITOR_IDENTITY_BACKFILLER": "visitor-identity/identity-backfiller"
    },
    "WLL": {
        "ADMIN": "wll/admin",
        "WLL_ENGINEER": "wll/engineer",
        "WLL_EVENT_OFFLINE_WRITER": "wll/event-offline-writer",
        "WLL_REACTION_OFFLINE_READER": "wll/reaction-offline-reader",
        "WLL_USER_OFFLINE_WRITER": "wll/user-offline-writer"
    }
};

var SCOPES = {
    "AAA": {
        "ADMIN": "aaa/admin",
        "ADVISOR_DELETE_NEWS": "aaa/advisor-news/delete",
        "ADVISOR_DELETE_VIDEO": "aaa/advisor-video/delete",
        "ADVISOR_PROFILE_UPDATE_MY": "aaa/advisor-profile/update-my",
        "ADVISOR_UPDATE_NEWS": "aaa/advisor-news/update",
        "ADVISOR_UPDATE_VIDEO": "aaa/advisor-video/update",
        "ANSWER_UPDATE_ALL": "aaa/answer/update-all",
        "ANSWER_UPDATE_MY": "aaa/answer/update-my",
        "QUESTION_ANSWER": "aaa/question/answer",
        "QUESTION_ANSWER_ANY": "aaa/question/answer-any",
        "QUESTION_ANSWER_PREVIEW": "aaa/question/answer/preview",
        "QUESTION_READ_ALL": "aaa/question/read-all",
        "QUESTION_UPDATE_ALL": "aaa/question/update-all",
        "QUESTION_UPDATE_MY": "aaa/question/update-my"
    },
    "ALPS": {
        "BANKING_DATA_READ_ALL": "alps/banking-data/read-all",
        "BANKING_DATA_WRITE_ALL": "alps/banking-data/write-all",
        "CC_DATA_READ_ALL": "alps/cc-data/read-all",
        "CC_DATA_WRITE_ALL": "alps/cc-data/write-all",
        "INTERNAL_DATA_READ": "alps/internal_data/read-all",
        "INTERNAL_DATA_WRITE": "alps/internal_data/write-all",
        "INVESTING_DATA_READ_ALL": "alps/investing-data/read-all",
        "INVESTING_DATA_WRITE_ALL": "alps/investing-data/write-all",
        "READ_ALL": "alps/all-data/read-all",
        "SENSIITVE_DATA_READ_ALL": "alps/sensitive-data/read-all",
        "WRITE_ALL": "alps/all-data/write-all"
    },
    "ANALYZE": {
        "ANALYZE_TU_PROFILE_OFFLINE_LINK": "analyze/tu-profile/offline-link"
    },
    "ANTIFRAUD": {
        "ACTIVITY_REPORT_ALL": "anti-fraud/activity/report-all",
        "ACTIVITY_REPORT_ALL_OFFLINE": "anti-fraud/activity/report-all-offline",
        "DECRYPT_AFS_LOGS": "anti-fraud/audit-log/decrypt-all",
        "EMAIL_BLOCKED_READ_ALL": "anti-fraud/email-blocked/read-all",
        "EMAIL_BLOCKED_READ_ALL_OFFLINE": "anti-fraud/email-blocked/read-all-offline",
        "EMAIL_BLOCKED_WRITE_ALL": "anti-fraud/email-blocked/write-all"
    },
    "ATOMIC": {
        "ACCOUNTS_READ_MY": "atomic/accounts/treasury-read-my",
        "ACCOUNTS_WRITE_MY": "atomic/accounts/treasury-write-my"
    },
    "BANKING": {
        "CACHE_DELETE": "banking/cache/delete"
    },
    "BST": {
        "BST_VIEW_CONTENT": "bst/content/view"
    },
    "CC": {
        "FEATURE_FLAG_WRITE": "cc/feature-flag/write",
        "INTERNAL_DATA_READ": "cc/internal-data/read",
        "PREVIEW_DATA_READ": "cc/preview-data/read",
        "PREVIEW_DATA_WRITE": "cc/preview-data/write",
        "PROD_DATA_OFFLINE_WRITE": "cc/prod-data-offline/write",
        "PROD_DATA_WRITE": "cc/prod-data/write",
        "RAW_DATA_READ": "cc/raw-data/read"
    },
    "CLO": {
        "CLO_READ_ALL_OFFLINE": "card-linked-offers/read-all-offline",
        "CLO_READ_ALL_WEBHOOKS": "card-linked-offers/read-all-webhooks",
        "CLO_SCRIPTS_RUN_ALL": "card-linked-offers/scripts-run-all",
        "CLO_USER_ID_READ_ALL": "card-linked-offers/users/empyr_id/read-all",
        "CLO_USER_ID_READ_MY": "card-linked-offers/users/empyr_id/read-my"
    },
    "DENALI": {
        "PLACEMENT_READ_ALL_OFFLINE": "denali/placements/read-all-offline"
    },
    "DIT": {
        "ACTION_PLAN_CANONICAL_WRITE": "dit/action-plan/canonical-write",
        "ACTION_PLAN_READ_ALL": "dit/action-plan/read-all",
        "ACTION_PLAN_WRITE_ALL": "dit/action-plan/write-all",
        "CAN_GIVE_ADVICE": "dit/give-financial-advice",
        "CONVERSATION_ARCHIVE_ALL": "dit/conversation/archive-all",
        "CONVERSATION_ASSIGN_ALL": "dit/conversation/assign-all",
        "CONVERSATION_DEACTIVATE": "dit/conversation/deactivate",
        "CONVERSATION_DELETE_ALL": "dit/conversation/delete-all",
        "CONVERSATION_JOIN_ALL": "dit/conversation/join-all",
        "CONVERSATION_READ_ALL": "dit/conversation/read-all",
        "CONVERSATION_READ_DEACTIVATED": "dit/conversation/read-deactivated",
        "EXPERT_ACTIVITY_READ_ALL": "dit/expert-activity/read-all",
        "EXPERT_WRITE_ALL": "dit/expert/write-all",
        "INVITE_SEND": "dit/invite/send",
        "NOTE_READ_ALL": "dit/note/read-all",
        "NOTE_WRITE_ALL": "dit/note/write-all",
        "QUESTION_WRITE": "dit/question/write",
        "SAVED_MESSAGE_READ": "dit/saved-message/read",
        "SAVED_MESSAGE_WRITE": "dit/saved-message/write",
        "SEND_NOTIFICATION": "dit/notify/send",
        "SUMMARIZE_URL": "dit/summarize/url",
        "TAG_CONVERSATION": "dit/tag-conversation/create",
        "TAG_CREATE": "dit/tag/create",
        "USER_FEEDBACK_READ_ALL": "dit/user-feedback/read-all",
        "USER_READ_ALL": "dit/user/read-all"
    },
    "DSS": {
        "IMPORT_DATASET": "dss/dataset/import",
        "READ_DATASET_METADATA": "dss/dataset-metadata/read",
        "READ_DATASET_PROCESS_DATA": "dss/dataset-process/read",
        "WRITE_DATASET_METADATA": "dss/dataset-metadata/write"
    },
    "DWH": {
        "DATA_READ": "dwh/data/read"
    },
    "FACTORY": {
        "FACTS_EVAL_ALL_OFFLINE": "factory/facts/eval-all-offline",
        "FACTS_OVERRIDE": "factory/facts/override",
        "FACTS_READ_ALL": "factory/facts/read-all",
        "FACTS_READ_ALL_OFFLINE": "factory/facts/read-all-offline",
        "FACTS_WRITE_ALL": "factory/facts/write-all"
    },
    "FDP": {
        "FDP_ACCOUNTS_READ_ALL": "fdp/accounts/read-all",
        "FDP_ENTITY_WRITE_MY": "fdp/financial-data/write-my",
        "FDP_FINANCIAL_DATA_TRANSFORM": "fdp/financial-data/transform",
        "FDP_FINANCIAL_PORTALS_READ_ALL": "fdp/financial-portals/read-all",
        "FDP_FINANCIAL_PORTALS_SOURCE_META_READ_ALL": "fdp/financial-portals/source-meta/read-all",
        "FDP_INSTITUTIONS_TRIGGER_INGEST": "fdp/institutions/trigger-ingest",
        "FDP_PLAID_FINANCIAL_PORTALS_WRITE_ALL_OFFLINE": "fdp/plaid-source-plugin/financial-portals/write-all-offline",
        "FDP_READ_ALL_OFFLINE": "fdp/financial-data/read-all-offline",
        "FDP_REDFIN_SOURCE_WRITE_ALL_OFFLINE": "fdp/redfin-source/write-all-offline",
        "FDP_ROLLUPS_READ_ALL_OFFLINE": "fdp/rollups/read-all-offline",
        "FDP_ROLLUPS_WRITE_ALL_OFFLINE": "fdp/rollups/write-all-offline",
        "FDP_USER_TRANSACTION_RULES_WRITE_ALL_OFFLINE": "fdp/user-transaction-rules/write-all-offline",
        "FDP_WRITE_ALL_OFFLINE": "fdp/financial-data/write-all-offline",
        "FDP_WRITE_PLAID_SOURCE": "fdp/plaid-source/write",
        "FDP_WRITE_QA_SOURCE": "fdp/qa-source/write",
        "FDP_WRITE_REDFIN_SOURCE": "fdp/redfin-source/write",
        "FDP_WRITE_TEMPLATES_QA_SOURCE": "fdp/qa-source-templates/write",
        "FDP_WRITE_USER_SOURCE": "fdp/user-source/write-all-offline"
    },
    "FEATURES": {
        "FEATURE_FLAG_OVERRIDE": "features/feature-flags/override",
        "FEATURE_FLAG_READ": "features/feature-flags/read",
        "FEATURE_FLAG_TRUST_PROVIDED_ROLES": "features/feature-flags/trust-provided-roles",
        "FEATURE_FLAG_WRITE": "features/feature-flags/write"
    },
    "FEED": {
        "FEED_CONFIG_READ_ALL": "feed/config/read-all",
        "FEED_READ_ALL": "feed/read-all"
    },
    "HOME": {
        "CACHE_DELETE": "home/cache/delete"
    },
    "IDENTITY": {
        "ACH_KYC_ADDRESS_PROFILE_READ_ALL_OFFLINE": "identity/ach-kyc-address-profile/read-all-offline",
        "ANTI_FRAUD_CALLBACKS_CALL_OFFLINE": "identity/anti-fraud-callbacks/call-offline",
        "ASK_MY_FRIENDS_PROFILE_READ_ALL": "identity/ask-my-friends-profile/read-all",
        "CARD_LINKED_OFFERS_PROFILE_READ_ALL_OFFLINE": "identity/card-linked-offers-profile/read-all-offline",
        "CONTACT_PROFILE_READ_ALL": "identity/contact-profile/read-all",
        "CREDIT_BUILDER_PROFILE_READ_ALL": "identity/credit-builder-profile/read-all",
        "CREDIT_BUILDER_PROFILE_WRITE_ALL": "identity/credit-builder-profile/write-all",
        "DEBT_PROFILE_READ_ALL_OFFLINE": "identity/debt-profile/read-all-offline",
        "DEBT_PROFILE_WRITE_ALL_OFFLINE": "identity/debt-profile/write-all-offline",
        "DIT_USER_PROFILE_WRITE": "identity/dit-user-profile/write",
        "EMAIL_PROFILE_READ_ALL_OFFLINE": "identity/email-profile/read-all-offline",
        "EMAIL_PROFILE_RESET_VERIFIED_MY": "identity/email-profile/reset-verified-my",
        "EMAIL_PROFILE_WRITE_ALL_OFFLINE": "identity/email-profile-write-all-offline",
        "EMAIL_SEND_ANY": "identity/email/send-any",
        "ENGAGEMENT_PROFILE_WRITE_MY": "identity/engagement-profile/write-my",
        "FINANCIAL_DATA_WRITE_ALL": "identity/financial-data/write-all",
        "FINANCIAL_INSTITUTION_PARTNER_PROFILE_READ_ALL": "identity/financial-institution-partner-profile/read-all",
        "FINANCIAL_INSTITUTION_PARTNER_PROFILE_WRITE_ALL": "identity/financial-institution-partner-profile/write-all",
        "FINANCIAL_INSTITUTION_PARTNER_PROFILE_WRITE_MY": "identity/financial-institution-partner-profile/write-my",
        "GLOBAL_PROFILE_READ_ALL": "identity/global-profile/read-all",
        "GLOBAL_PROFILE_READ_ALL_OFFLINE": "identity/global-profile/read-all-offline",
        "GLOBAL_PROFILE_READ_DIT_USERS": "identity/global-profile/read-dit-users",
        "GLOBAL_PROFILE_WRITE_ALL": "identity/global-profile/write-all",
        "GLOBAL_PROFILE_WRITE_ALL_OFFLINE": "identity/global-profile/write-all-offline",
        "GOALS_PROFILE_READ_ALL_OFFLINE": "identity/goals-profile/read-all-offline",
        "IAV_ACCOUNT_DETAILS_READ_ALL": "identity/iav-account-details/read-all",
        "IAV_ACCOUNT_DETAILS_READ_MY": "identity/iav-account-details/read-my",
        "IDENTITY_ADMIN_PASSWORD_RESET": "identity/identity/admin-password-reset",
        "IDENTITY_APP_LEVEL_IDENTITY_WRITE": "identity/app-level-identity/write",
        "IDENTITY_AUTH_PROVIDER_UNLINK_ALL": "identity/auth-provider/unlink-all",
        "IDENTITY_DEACTIVATE_ALL": "identity/identity/deactivate-all",
        "IDENTITY_FORGET_ALL": "identity/identity/forget-all",
        "IDENTITY_METADATA_READ_ALL": "identity/identity-metadata/read-all",
        "IDENTITY_READ_ALL": "identity/identity/read-all",
        "IDENTITY_READ_ALL_OFFLINE": "identity/identity/read-all-offline",
        "IDENTITY_READ_DIT_USERS": "identity/identity/read-dit-users",
        "IDENTITY_ROLLBACK_PASSWORD_ALL": "identity/identity/rollback-password-all",
        "IDENTITY_SCRIPT_RUN": "identity/identity-script/run",
        "IDENTITY_UNSUBSCRIBE_ALL": "identity/identity/unsubscribe-all",
        "IDENTITY_UNSUBSCRIBE_ALL_OFFLINE": "identity/identity/unsubscribe-all-offline",
        "LEGACY_FEED_READ_ALL_OFFLINE": "identity/user-feed-legacy/read-all",
        "MERCHANTS_WRITE_ALL": "identity/merchants/write-all",
        "MERCHANTS_WRITE_ALL_OFFLINE": "identity/merchants/write-all-offline",
        "MERCHANT_RULES_WRITE_ALL": "identity/merchant-rules/write-all",
        "MERCHANT_RULES_WRITE_ALL_OFFLINE": "identity/merchant-rules/write-all-offline",
        "MONETIZATION_PROFILE_WRITE_MY": "identity/monetization-profile/write-my",
        "NW_PLUS_MEMBER_WRITE_ALL_OFFLINE": "identity/nw-plus-member/write-all-offline",
        "PERSONAL_LOANS_PROFILE_READ_ALL_OFFLINE": "identity/personal-loans-profile/read-all-offline",
        "PHONE_NUMBER_ALLOW_REUSE": "identity/phone-number/allow-reuse",
        "ROLE_READ_ALL": "identity/role/read-all",
        "ROLE_WRITE_AAA": "identity/role/write-aaa",
        "ROLE_WRITE_ALL": "identity/role/write-all",
        "ROLE_WRITE_BANKING": "identity/role/write-banking",
        "ROLE_WRITE_BIZ_DEV": "identity/role/write-biz-dev",
        "ROLE_WRITE_BST": "identity/role/write-bst",
        "ROLE_WRITE_CC": "identity/role/write-cc",
        "ROLE_WRITE_COMMS": "identity/role/write-comms",
        "ROLE_WRITE_COMPLIANCE": "identity/role/write-compliance",
        "ROLE_WRITE_DENALI": "identity/role/write-denali",
        "ROLE_WRITE_DIGITAL_MARKETING": "identity/role/write-digital-marketing",
        "ROLE_WRITE_DIT": "identity/role/write-dit",
        "ROLE_WRITE_DSS": "identity/role/write-dss",
        "ROLE_WRITE_ENGINEER": "identity/role/write-engineer",
        "ROLE_WRITE_ESTATE_PLANNING": "identity/role/write-estate-planning",
        "ROLE_WRITE_EXPANSION": "identity/role/write-expansion",
        "ROLE_WRITE_EXTERNAL_TESTERS": "identity/role/write-external-testers",
        "ROLE_WRITE_FDP": "identity/role/write-fdp",
        "ROLE_WRITE_HOME": "identity/role/write-home",
        "ROLE_WRITE_INSURANCE": "identity/role/write-insurance",
        "ROLE_WRITE_INTERNAL_TESTERS": "identity/role/write-internal-testers",
        "ROLE_WRITE_INVESTING": "identity/role/write-investing",
        "ROLE_WRITE_LOANS": "identity/role/write-loans",
        "ROLE_WRITE_MARKETPLACE": "identity/role/write-marketplace",
        "ROLE_WRITE_ML_PLATFORM": "identity/role/write-ml-platform",
        "ROLE_WRITE_MOVING": "identity/role/write-moving",
        "ROLE_WRITE_QUALITY_ASSURANCE": "identity/role/write-quality-assurance",
        "ROLE_WRITE_QUALITY_ASSURANCE_ENGINEER": "identity/role/write-quality-assurance-engineer",
        "ROLE_WRITE_SOFTWARE": "identity/role/write-software",
        "ROLE_WRITE_SWEEP": "identity/role/write-sweep",
        "ROLE_WRITE_TAXES": "identity/role/write-taxes",
        "ROLE_WRITE_THIRD_PARTY_EMBEDS": "identity/role/write-third-party-embeds",
        "ROLE_WRITE_TU": "identity/role/write-transunion",
        "ROLE_WRITE_UCP": "identity/role/write-ucp",
        "ROLE_WRITE_UDP": "identity/role/write-udp",
        "ROLE_WRITE_UTILITIES": "identity/role/write-utilities",
        "ROLE_WRITE_WLL": "identity/role/write-wll",
        "SECURITY_PROFILE_READ_ALL": "identity/security-profile/read-all",
        "SECURITY_PROFILE_WRITE_ALL": "identity/security-profile/write-all",
        "SECURITY_PROFILE_WRITE_MY": "identity/security-profile/write-my",
        "SUBSCRIPTION_PROFILE_READ_ALL_OFFLINE": "identity/subscription-profile/read-all-offline",
        "SUBSCRIPTION_PROFILE_WRITE_ALL_OFFLINE": "identity/subscription-profile/write-all-offline",
        "TEST_STATE_PROFILE_READ_ALL_OFFLINE": "identity/test-state-profile/read-all-offline",
        "TEST_STATE_PROFILE_READ_MY": "identity/test-state-profile/read-my",
        "TEST_STATE_PROFILE_WRITE_MY": "identity/test-state-profile/write-my",
        "TU_META_WRITE_ALL_OFFLINE": "identity/tu-meta/write-all-offline",
        "TU_PROFILE_READ_ALL": "identity/tu-profile/read-all",
        "TU_PROFILE_WRITE_MY": "identity/tu-profile/write-my",
        "USER_FEED_ITEM_WRITE_ALL": "identity/user-feed-item/write-all",
        "USER_FEED_ITEM_WRITE_MY": "identity/user-feed-item/write-my",
        "USER_OPS_PROFILE_READ_ALL": "identity/user-ops-profile/read-all",
        "USER_RESEARCH_PROFILE_WRITE_MY": "identity/user-research-profile/write-my",
        "VERIFICATION_RECORDS_READ_ALL": "identity/verification-records/read-all",
        "VERIFICATION_RECORDS_READ_ALL_OFFLINE": "identity/verification-records/read-all-offline",
        "YODLEE_PROFILE_WRITE_MY": "identity/yodlee-profile/write-my",
        "YODLEE_PROVIDERS_WRITE": "identity/yodlee/providers/write",
        "YODLEE_READ_ALL_OFFLINE": "identity/yodlee/read-all-offline",
        "YODLEE_REWARD_ACCOUNT_READ_MY": "identity/yodlee/reward-account/read-my"
    },
    "IMS": {
        "LEAD_READ_MY": "ims/lead/read-my",
        "LEAD_WRITE_MY": "ims/lead/write-my",
        "POLICIES_ENCRYPTED_IDENTITY_ID_READ_MY": "ims/policies/encrypted-identity-id/read-my",
        "POLICIES_READ_MY": "ims/policies/read-my",
        "POLICIES_RECONNECT_TOKEN_WRITE_MY": "ims/policies/reconnect-token/write-my",
        "POLICY_READ_MY": "ims/policy/read-my",
        "POLICY_WRITE_MY": "ims/policy/write-my",
        "QUOTES_READ_MY": "ims/quotes/read-my"
    },
    "LABORATORY": {
        "READ_ALL": "laboratory/all-data/read",
        "WRITE_ALL": "laboratory/all-data/write"
    },
    "LEX": {
        "FINANCIAL_HEALTH_SCORE_READ_ALL_OFFLINE": "lex/financial-health-score/read-all-offline"
    },
    "MARKETPLACE": {
        "ACCOUNT_AGGREGATION_READ": "marketplace/account-aggregation/read",
        "ACCOUNT_AGGREGATION_WRITE": "marketplace/account-aggregation/write",
        "AFFILIATE_PAYOUT_READ": "marketplace/affiliate-payout/read",
        "AFFILIATE_PAYOUT_READ_OFFLINE": "marketplace/affiliate-payout/read-offline",
        "AFFILIATE_PAYOUT_WRITE": "marketplace/affiliate-payout/write",
        "AFFILIATE_PAYOUT_WRITE_OFFLINE": "marketplace/affiliate-payout/write-offline",
        "ALL_EXTERNAL_ID_WRITE": "marketplace/all-data/external-id-write",
        "ALL_READ": "marketplace/all-data/read",
        "ALL_SCHEMA_WRITE": "marketplace/all-schema-data/write",
        "ALL_WRITE": "marketplace/all-data/write",
        "AUTO_LOANS_READ": "marketplace/auto-loans-data/read",
        "AUTO_LOANS_READ_CONTENT": "marketplace/auto-loans-data-content/read",
        "AUTO_LOANS_WRITE": "marketplace/auto-loans-data/write",
        "AUTO_LOANS_WRITE_CONTENT": "marketplace/auto-loans-data-content/write",
        "BANKING_READ": "marketplace/banking-data/read",
        "BANKING_SENSITIVE_READ": "marketplace/banking-sensitive-data/read",
        "BANKING_SENSITIVE_WRITE": "marketplace/banking-sensitive-data/write",
        "BANKING_WRITE": "marketplace/banking-data/write",
        "CANONICAL_READ": "marketplace/canonical/read",
        "CANONICAL_WRITE": "marketplace/canonical/write",
        "CREDIT_CARDS_READ": "marketplace/credit-cards-data/read",
        "CREDIT_CARDS_WRITE": "marketplace/credit-cards-data/write",
        "EDU_READ": "marketplace/edu-data/read",
        "EDU_READ_CONTENT": "marketplace/edu-data-content/read",
        "EDU_WRITE": "marketplace/edu-data/write",
        "EDU_WRITE_CONTENT": "marketplace/edu-data-content/write",
        "ESTATE_PLANNING_READ": "marketplace/estate-planning/read",
        "ESTATE_PLANNING_WRITE": "marketplace/estate-planning/write",
        "EXPANSION_READ": "marketplace/expansion/read",
        "EXPANSION_WRITE": "marketplace/expansion/write",
        "FTHB_READ": "marketplace/fthb-data/read",
        "FTHB_WRITE": "marketplace/fthb-data/write",
        "INSURANCE_READ": "marketplace/insurance/read",
        "INSURANCE_WRITE": "marketplace/insurance/write",
        "INVESTING_READ": "marketplace/investing-data/read",
        "INVESTING_SENSITIVE_READ": "marketplace/investing-sensitive-data/read",
        "INVESTING_SENSITIVE_WRITE": "marketplace/investing-sensitive-data/write",
        "INVESTING_WRITE": "marketplace/investing-data/write",
        "MORTGAGES_READ": "marketplace/mortgages-data/read",
        "MORTGAGES_READ_CONTENT": "marketplace/mortgages-data-content/read",
        "MORTGAGES_SENSITIVE_READ": "marketplace/mortgages-sensitive-data/read",
        "MORTGAGES_SENSITIVE_WRITE": "marketplace/mortgages-sensitive-data/write",
        "MORTGAGES_WRITE": "marketplace/mortgages-data/write",
        "MORTGAGES_WRITE_CONTENT": "marketplace/mortgages-data-content/write",
        "MOVING_READ": "marketplace/moving/read",
        "MOVING_WRITE": "marketplace/moving/write",
        "PERSONAL_LOANS_READ": "marketplace/personal-loans-data/read",
        "PERSONAL_LOANS_READ_CONTENT": "marketplace/personal-loans-data-content/read",
        "PERSONAL_LOANS_WRITE": "marketplace/personal-loans-data/write",
        "PERSONAL_LOANS_WRITE_CONTENT": "marketplace/personal-loans-data-content/write",
        "SMB_LOANS_READ": "marketplace/smb-loans-data/read",
        "SMB_LOANS_WRITE": "marketplace/smb-loans-data/write",
        "SOFTWARE_READ": "marketplace/software/read",
        "SOFTWARE_WRITE": "marketplace/software/write",
        "TAXES_READ": "marketplace/taxes/read",
        "TAXES_WRITE": "marketplace/taxes/write",
        "THIRD_PARTY_EMBEDS_READ": "marketplace/third-party-embeds/read",
        "THIRD_PARTY_EMBEDS_WRITE": "marketplace/third-party-embeds/write",
        "UTILITIES_READ": "marketplace/utilities/read",
        "UTILITIES_WRITE": "marketplace/utilities/write"
    },
    "META": {
        "APP_LOCK_ENABLED": "meta/app-lock/enabled",
        "AUTHENTICATION_METHOD_READ": "meta/authentication-method/read",
        "AUTHENTICATION_METHOD_WRITE": "meta/authentication-method/write",
        "CAPTCHA_PASSED": "meta/captcha/passed",
        "PASSWORD_SECURE_RESET": "meta/password/secure-reset",
        "PASSWORD_SECURE_UPDATE": "meta/password/secure-update",
        "TRANSUNION_ACTIVATED": "meta/transunion/activated",
        "VERIFIED_PHONE_EXISTS": "meta/verified-phone-number/exists"
    },
    "ML_PLATFORM": {
        "INSIGHTS_METADATA_READ": "ml-platform/insights/metadata-read",
        "INSIGHTS_METADATA_READ_OFFLINE": "ml-platform/insights/metadata-read-offline",
        "INSIGHTS_METADATA_WRITE": "ml-platform/insights/metadata-write",
        "INSIGHTS_METADATA_WRITE_OFFLINE": "ml-platform/insights/metadata-write-offline",
        "INSIGHTS_READ_ALL": "ml-platform/insights/read-all",
        "INSIGHTS_READ_ALL_OFFLINE": "ml-platform/insights/read-all-offline",
        "SAGEMAKER_ENDPOINT_DELETE_OFFLINE": "ml-platform/sagemaker-endpoint/delete-offline",
        "SAGEMAKER_ENDPOINT_UPSERT_OFFLINE": "ml-platform/sagemaker-endpoint/upsert-offline",
        "SAGEMAKER_MODEL_DELETE_OFFLINE": "ml-platform/sagemaker-model/delete-offline",
        "SAGEMAKER_MODEL_UPSERT_OFFLINE": "ml-platform/sagemaker-model/upsert-offline",
        "SAGEMAKER_REALTIME_CONFIG_DELETE_OFFLINE": "ml-platform/sagemaker-realtime-config/delete-offline",
        "SAGEMAKER_REALTIME_CONFIG_READ_ALL_OFFLINE": "ml-platform/sagemaker-realtime-config/read-all-offline",
        "SAGEMAKER_REALTIME_CONFIG_UPSERT_OFFLINE": "ml-platform/sagemaker-realtime-config/upsert-offline",
        "SAGEMAKER_REALTIME_INSIGHTS_READ_ALL_OFFLINE": "ml-platform/sagemaker/insights/read-all-offline"
    },
    "MUSEUM": {
        "APP_WRITE": "museum/application/write",
        "ENV_WRITE": "museum/environment/write",
        "NOMINATION_WRITE": "museum/nomination/write"
    },
    "NERDWALLET": {
        "DEV_MENU_ACCESS": "nerdwallet/dev-menu/access",
        "EXTERNAL_BETA_FEATURE_ACCESS": "nerdwallet/external-beta-feature/access",
        "INTERNAL_FEATURE_ACCESS": "nerdwallet/internal-feature/access",
        "INTERNAL_TOOL_ACCESS": "nerdwallet/internal-tool/access"
    },
    "PREQUAL_OFFERS": {
        "PREQUAL_OFFERS_READ_ALL_OFFLINE": "prequal/offers/read-all-offline",
        "PREQUAL_OFFERS_WRITE_ALL_OFFLINE": "prequal/offers/write-all-offline"
    },
    "RECURLY": {
        "ACCOUNTS_READ_MY": "recurly/accounts/read-my",
        "ACCOUNTS_WRITE_MY": "recurly/accounts/write-my"
    },
    "REWARDS": {
        "POINTS_GRANT": "rewards/points/grant",
        "PROFILES_READ_ALL": "rewards/profiles/read-all",
        "RAFFLE_READ_ALL": "rewards/raffle/read-all",
        "RAFFLE_WRITE_ALL": "rewards/raffle/write-all"
    },
    "TRANSUNION": {
        "TU_PROFILE_READER": "tu/credit-data/profile/read/all",
        "TU_SSN_READER": "tu/credit-data/ssn/read/all"
    },
    "UCP": {
        "ADMIN_TRIGGER_DATA_EXPORT": "ucp/ucp/trigger-data-export",
        "BLUESHIFT_MANAGE_SUBSCRIPTIONS_ALL": "ucp/blueshift/manage-subscriptions-all",
        "BLUESHIFT_USERS_READ_ALL": "ucp/blueshift/users/read-all",
        "COMMS_EVENT_EMIT": "ucp/event/emit",
        "COMMS_EXPORT_DATA_TO_ITERABLE": "ucp/export/iterable_data",
        "COMMS_UPDATE_APP_BADGE_COUNT_OFFLINE": "ucp/app-badge-count/update-offline",
        "COMMS_UPDATE_EMAIL_OFFLINE": "ucp/email/update-all-offline",
        "CONTENT_CATALOG_START_BATCH_PROCESS": "ucp/content-sync/start-batch-process",
        "DCE_REPLAY": "ucp/dce/replay",
        "ESP_FORGET_USERS_ALL": "ucp/esp/forget-users-all",
        "ITERABLE_USERS_READ_ALL": "ucp/iterable/users/read-all",
        "QA_COMMS_EMAIL_SEND": "ucp/email/send",
        "QA_COMMS_SEND_MOCK_URE_EVENT": "ucp/email/send/mock_ure_event",
        "QA_COMMS_SEND_TEST_WITH_MOCK_DATA": "ucp/email/send/mock_data",
        "QA_COMMS_SEND_TEST_WITH_REAL_DATA": "ucp/email/send/real_data",
        "REACTIVATE_COMMS_METADATA": "ucp/identity-comms-metadata/reactivate",
        "READ_COMMS_METADATA": "ucp/identity-comms-metadata/read",
        "WRITE_BATCH_WRITE_TABLES": "ucp/batch-write-tables/write",
        "WRITE_ITERABLE_USERS": "ucp/iterable/users/write"
    },
    "UDP": {
        "AFS_AUGMENTOR_CACHE_READ_ALL_OFFLINE": "udp/afs-augmentor-cache/read-all-offline",
        "AFS_AUGMENTOR_CACHE_WRITE_ALL_OFFLINE": "udp/afs-augmentor-cache/write-all-offline",
        "COLUMN_TAX_DATA_READ_ALL": "udp/column-tax-data/read-all",
        "COLUMN_TAX_DATA_WRITE_ALL": "udp/column-tax-data/write-all",
        "CONSUMER_DATA_CONTRIBS_READ_ALL": "udp/consumer-data-contributions/read-all",
        "CONSUMER_DATA_CONTRIBS_WRITE_ALL": "udp/consumer-data-contributions/write-all",
        "CONSUMER_PROFILE_READ_ALL": "udp/consumer-profile/read-all",
        "CONSUMER_PROFILE_WRITE_ALL": "udp/consumer-profile/write-all",
        "FINANCIAL_PRIORITIES_READ_ALL": "udp/financial-priorities/read-all",
        "MEMBER_BACKFILL_WRITE_ALL": "udp/member-backfill/write-all",
        "MEMBER_CCPA_WRITE_ALL": "udp/member-ccpa/write-all",
        "PROFILES_READ_ALL": "udp/profiles/read-all",
        "PROFILES_READ_ALL_OFFLINE": "udp/profiles/read-all-offline",
        "PROFILES_WRITE_ALL_OFFLINE": "udp/profiles/write-all-offline",
        "UNIFIED_USER_PROFILE_READ_ALL_OFFLINE": "udp/unified-user-profile/read-all-offline",
        "VISITOR_BACKFILL_WRITE_ALL": "udp/visitor-backfill/write-all",
        "VISITOR_PII_READ_ALL": "udp/visitor-profiles/pii-read-all",
        "VISITOR_PII_READ_ALL_OFFLINE": "udp/visitor-profiles/pii-read-all-offline"
    },
    "VISITOR_IDENTITY": {
        "EMAIL_WRITE_ALL": "visitor-identity/email/write-all",
        "RTP_WRITE_ALL": "visitor-identity/registration-tracking-profile/write-all"
    },
    "WEALTH_RECOMMENDER": {
        "ASSETS_AND_DEBTS_READ_ALL": "wealth-recommender/assets-debts/read-all-admin",
        "USERS_RECS_READ_ALL": "wealth-recommender/user-recs/read-all"
    },
    "WLL": {
        "EVENTS_READ_ALL": "wll/events/read-all",
        "EVENTS_WRITE_ALL_OFFLINE": "wll/events/write-all-offline",
        "EVENTS_WRITE_MY": "wll/events/write-my",
        "MICROSITE_READ_MY": "wll/microsite/read-my",
        "REACTIONS_READ_ALL_OFFLINE": "wll/reactions/read-all-offline",
        "REACTIONS_READ_MY": "wll/reactions/read-my",
        "REWARDS_WRITE_MY": "wll/rewards/write-my",
        "USERS_READ_ALL": "wll/users/read-all",
        "USERS_WRITE_ALL": "wll/users/write-all",
        "USERS_WRITE_ALL_OFFLINE": "wll/users/write-all-offline"
    }
};

module.exports = {
  APPS: APPS,
  ROLES: ROLES,
  SCOPES: SCOPES
};
